<mdb-navbar [SideClass]="navClassString" [containerInside]="containerInside">
    <logo *ngIf="!doubleNav"><a class="navbar-brand mr-0" [routerLink]="['/home']"><img src="{{logoUrl}}" alt="{{logoTitle}}"></a></logo>   
    <links>
    <div *ngIf="doubleNav" class="float-xs-left">
        <a (click)="toggleSideNav()" class="button-collapse"><i class="fa fa-bars"></i></a>
    </div>
      <ul class="navbar-nav ml-5 ml-sm-auto">
            <li class="nav-item">
                <a class="nav-link waves-light" mdbRippleRadius [routerLink]="['/']">Home</a>
            </li>
            <li class="nav-item" *ngFor="let navItem of navItems">
                <a class="nav-link waves-light" mdbRippleRadius (click)="handleItemClick(navItem, $event)"
              [routerLink]="navItem.routerLink">
              {{navItem.name}}</a>
            </li>
        </ul>
    </links>
</mdb-navbar>


// WEBPACK FOOTER //
// ./src/app/theme/navbar/navbar.component.html